import useSWR from "swr";
import { useMemo } from "react";
import axios, { endpoints } from "src/utils/axios";

// ----------------------------------------------------------------------
let lastHandshakedToken: string | null = null;

export function usePlacenetHandshake(placenetToken: string | null) {
  const shouldFetch = Boolean(placenetToken);

  const key = shouldFetch
    ? [endpoints._3rdparty.placenet.handshake, placenetToken]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(
    key,
    async ([url, token]) => {
      const res = await axios.get(url || "", {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    },
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      shouldRetryOnError: false,
    }
  );

  return useMemo(
    () => ({
      handshake: data ?? null,
      handshakeLoading: shouldFetch && isLoading,
      handshakeError: shouldFetch ? error : null,
      handshakeValidating: isValidating,
      handshakeReady: !shouldFetch || (!!data && !isLoading),
      isExistingUser: data?.status === "existing",
      isFirstTimeUser: data?.status === "first_time",
    }),
    [data, error, isLoading, isValidating, shouldFetch]
  );
}
